import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-close",
  "use": "tamr-icon-close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-close\"><path d=\"M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30Z\" /><path d=\"M22.4,9.6a1,1,0,0,0-1.4,0L16,14.6,11.1,9.6a1,1,0,0,0-1.4,1.4L14.6,16,9.6,20.9a1,1,0,1,0,1.4,1.4L16,17.4l4.9,4.9a1,1,0,0,0,1.4-1.4L17.4,16l4.9-4.9A1,1,0,0,0,22.4,9.6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol